import { AbstractControl, UntypedFormControl, ValidationErrors } from '@angular/forms';
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';
import { StringHelper } from 'apps/idl/src/helpers/stringHelper';
import { IContact, RouteComponent } from 'apps/idl/src/model';
import { PermissionsService } from 'apps/idl/src/modules/permissions/services/permissions.service';
import { InjectorService } from 'apps/idl/src/services/security/injector.service';
import { C_DESMOS_PERMISSION_ID } from '../app/app.constants';

export abstract class IdlComponentRegister {

	//#region FIELDS

	/** Tableau de tous les composants d'Idlizy. */
	private static readonly maComponents: RouteComponent[] = [];

	//#endregion

	//#region METHODS

	/** Retourne tous les composants spécifiques d'Idlizy, avec leurs id. */
	public static getIdlRouteComponents(): RouteComponent[] {
		return this.maComponents;
	}

	//#endregion

}

//#region FORMLY

//#region RPPS

/** Fonction qui retourne un message (d'erreur) si le rpps est invalide. */
export function getRppsMessageErrorFunction(poError, poField: FormlyFieldConfig): string {
	return `Numéro RPPS non valide (11 chiffres uniquement).`;
};
/** Fonction qui retourne un message (d'erreur) si le numéro ADELI est invalide. */
export function getADELIMessageErrorFunction(poError, poField: FormlyFieldConfig): string {
	return `Numéro ADELI non valide (ex: 758035885 ou 2B6021939).`;
};

/** Fonction qui retourne un message (d'erreur) si le numéro FINESS est invalide. */
export function getFINESSMessageErrorFunction(poError, poField: FormlyFieldConfig): string {
	return `Numéro FINESS non valide (ex: 758035885 ou 2B6021939).`;
};

export function mustHideIntervenantFieldFunction(poModel: IContact): boolean {
	return false;
};

/** Fonction qui retourne `true` si un médecin doit être caché, `false` sinon. */
export function mustHideMedcinFieldFunction(poModel: IContact): boolean {
	return false;
};

export function mustHideActionButtonFieldConversationFunction(): boolean {
	return false;
};

export function mustHideActionButtonFSVFunction(): boolean {
	return false;
};

/** Fonction qui retourne `true` si un champ desmos doit être caché, `false` sinon. */
export function mustHideDesmosFieldFunction(): boolean {
	return !InjectorService.instance.get(PermissionsService).evaluatePermission(C_DESMOS_PERMISSION_ID, "edit");
};

/** Fonction qui retourne `true` si un champ desmos doit être caché, `false` sinon. */
export function mustHideFSVFieldFunction(): boolean {
	return false;
};

/** Fonction qui retourne `true` si un champ agrément doit être caché, `false` sinon. */
export function mustHideAdminAgrementFieldFunction(poModel: IContact): boolean {
	return true;
};

//#endregion

//#region NIR

/** Fonction de validation du nir, retourne `null` si non renseigné, un objet d'erreur sinon. */
export function nirValidatorFunction(poFormControl: UntypedFormControl): ValidationErrors {
	const lsNir: string = poFormControl.value;

	if (StringHelper.isBlank(lsNir)) // Si nir vide alors le champ n'est pas obligatoire.
		return null;
	else // Si le nir est renseigné, il faut qu'il soit valide pour que le champ soit valide.
		return null;
};

//#endregion

//#endregion

/** Objet de configuration spécifiques à IDL concernant les formulaires (champs, validateurs, ...). */
export const IDL_FORMLY_CONFIG_OPTION: ConfigOption = {
	types: [],
	wrappers: [],
	validators: [],
	validationMessages: []
};